import React from "react";
import {
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";

const ScreenshotModal = ({ url, onClose }) => (
  <Modal isOpen={!!url} onClose={onClose} size="xl" isCentered>
    <ModalOverlay />
    <ModalContent>
      <ModalCloseButton />
      <ModalBody p={4}>
        <Image src={url} alt="Trade screenshot" w="100%" objectFit="contain" />
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default ScreenshotModal;
